export const validDocumentImageExtensions = ['png', 'gif', 'jpg', 'jpeg'];

export const validImageExtensions = validDocumentImageExtensions;

export const validImageMimeTypes = ['image/png', 'image/gif', 'image/jpeg'];
